/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-irregular-whitespace */
import styles from 'components/cases/common/Interview/Interview.module.scss'
import TitleFlex from 'components/cases/common/TitleFlex'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import React from 'react'
import InterviewContents from 'components/cases/common/Interview/InterviewContents'
import { ContentData } from '../../common/Interview/fragments/type'

const sectionTitle = {
  title: 'Interview',
  sub_title: 'インタビュー',
}

const contentData: ContentData[][] = [
  [
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/volunteerex/volunteerEx/interview1.webp',
      alt: 'インタビュー写真',
      text: '左から公益財団法人日本財団ボランティアセンターのプロジェクトコーディネーター 高野葉朗さん、常務理事 沢渡一登さん、アイスリーデザイン xRコミュニケーションデザイン部 プロジェクトマネージャー 北原',
    },
    {
      type: 'textBox',
      texts: [
        '公益財団法人日本財団ボランティアセンターは、2010年に前身「NPO法人日本学生ボランティアセンター」として設立され、現在は学生だけではなく幅広い世代を対象にボランティアに関する事業を実施している公益財団法人です。',
        'アイスリーデザインは、日本財団ボランティアセンターと共同で、水害支援に特化したボランティア活動が体験できるVR（Virtual Reality）コンテンツを開発しました。',
        'このコンテンツに込めた思い、そして制作プロジェクトとその進行について、公益財団法人日本財団ボランティアセンターの常務理事 沢渡一登さん、プロジェクトコーディネーターの高野葉朗さんにお話を伺いました。',
      ],
      wide: true,
      bold: false,
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '自主提案から始まったVRコンテンツ制作',
    },
    {
      type: 'textBox',
      texts: ['―― 本プロジェクト開始のきっかけを教えてください。'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '沢渡さん',
      texts: [
        '以前からお仕事を一緒にしていたアイスリーデザインの北原さんより、企画をご提案いただいたのがきっかけです。日本財団ボランティアセンターはボランティアに関する様々なことを行っているのですが、僕と高野の二人は主に災害ボランティアを担当していて、災害が起きたら現地に行ったり、全国から集まるボランティアの方々と地域のニーズをマッチングさせて現場のコーディネートをしています。ボランティアはその性質上、現場ごとに集まってくださる方も異なるので、危険性なども含め、いつも最初から丁寧に説明し、マネジメントすることが必要となります。北原さんはそうした僕らの仕事を見ていてくれて、「VRで解決できるのではないか」と企画を考えてくれました。',
      ],
    },
    {
      type: 'greyBox',
      name: '北原',
      texts: [
        '前職の頃から沢渡さんとお仕事をご一緒しているのですが、その様子からボランティアのマネジメントが本当に大変だということがわかっていたんです。そうした課題に対して、VRコンテンツでお助けができるのではないかとご提案させていただきました。',
      ],
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/volunteerex/volunteerEx/interview2.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: ['―― 今回、どうしてこの内容をテーマに、VRを制作されたのですか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '沢渡さん',
      texts: [
        'ボランティアという性質上、集まってくださる方々は当日初めて参加するという方も多くなります。また、災害現場の活動では、身の安全を守るためにも細心の注意が必要となり、毎回丁寧に最初から説明を行っていくことが大切になります。それをVRという手段を用いることで、危険性を疑似体験して感じてもらうことができるということで制作することに決めました。そして、近年水害が増えているということや、浸水した家屋では、床下の構造を把握し、床板を剥がさないと泥出しができず、これらを知る機会が限られることから、 今回は水害支援にフォーカスすることになりました。',
      ],
    },
    {
      type: 'greyBox',
      name: '北原',
      texts: [
        'やったことがないボランティアについては、誰もが参加にハードルを感じてしまいがちです。VRで事前に疑似体験できれば、そのハードルを低くできると思いました。',
      ],
    },
    {
      type: 'textBox',
      texts: ['―― VRコンテンツとして意識しながら制作したことがあれば教えてください。'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '北原',
      texts: [
        'VRコンテンツはどうしてもゲームっぽくなりがちなのですが、今回はあくまでレクチャー教材になるようにバランス調整にとても気を遣いましたね。ゲーム的な満足感を醸成させながらも、あくまでも「ミッションに取り組む」ことによる達成感に重きを置いて制作を行いました。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '互いの強みを認識し、パートナーとして並走することができた',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/volunteerex/volunteerEx/interview3.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: ['―― 完成したVRコンテンツを見ていかがでしたか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '沢渡さん',
      texts: [
        '映像は観るだけですが、VRは主体的に取り組むという性質があるので、とても自然な形で手順を覚えられ、今までにない教材になっていると感じました。僕自身も水害支援のボランティアは何度も経験していますが、今回VRで体験することによって、改めて道具の選択の仕方など考えさせられる部分がありました。',
      ],
    },
    {
      type: 'greyBox',
      name: '高野さん',
      texts: [
        '装備をちゃんとしないと怪我したり、夢中になって水分補給を忘れていると熱中症になったりと、現場でも起こりうることが経験できるところがリアルだと思いました。これを5〜10分程度で体験できるので、災害支援を知るきっかけとしてとても入りやすいですよね。',
      ],
    },
    {
      type: 'greyBox',
      name: '沢渡さん',
      texts: [
        'アイスリーデザインさんにはVRの他に動画教材も作ってもらったのですが、その教材はボランティア研修でも活用されていて好評です。',
      ],
    },
    {
      type: 'textBox',
      texts: ['――プロジェクト全体を通して、アイスリーデザインの進行はいかがでしたか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '沢渡さん',
      texts: [
        'とにかく、アイスリーデザインさんからご提案をどんどんいただけたので、スピーディーにブラッシュアップを重ねることができ、結果としてとても意義のある教材を作ることができたと思っています。意見をしっかりと伝え合える関係性を築くことができたことが、このプロジェクトを成功させる上ですごく大きかったと感じますね。',
      ],
    },
    {
      type: 'greyBox',
      name: '北原',
      texts: [
        'ありがとうございます。なんでも言い合える関係でありながらも「なあなあ」にはならず、お互いの強みと役割分担を意識しながら良いものを作ることに集中できる進行を心掛けたので、そう言っていただけてとてもよかったです。',
      ],
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/volunteerex/volunteerEx/interview4.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: ['――制作において印象的なエピソードがあれば教えてください。'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '高野さん',
      texts: ['ターゲットをどこに定めるのかは結構悩みましたね。'],
    },
    {
      type: 'greyBox',
      name: '北原',
      texts: [
        'やはり画面に3DCGが映っていると、子どもたちにはゲームに見えるようで、思った以上に子どもが集まってすごいことになりました（笑）。楽しさから始まってボランティアに触れてもらうという流れはとても良いと感じましたね。今後も展示を行なっていくと伺っておりますので、そこでどんな層の方々が集まってくるのか反応を見てみたいと思っています。',
      ],
    },
    {
      type: 'greyBox',
      name: '沢渡さん',
      texts: [
        'それと日本財団ボランティアセンターのスタッフの中でも、災害ボランティアとは違う仕事をしているメンバーがたくさんいるのですが、彼らはこのVRを体験して「同僚の仕事を知ることができてよかった」ととても喜んでいたのも印象的でした。',
      ],
    },
  ],
  [
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/volunteerex/volunteerEx/interview5.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: ['―― 最後に今後の展望を教えていただけますか。'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '沢渡さん',
      texts: [
        '日本財団ボランティアセンターは、日本に新しいボランティアカルチャーをつくっていこうと日々仕事に取り組んでいます。日本においては阪神・淡路大震災のあった1995年がボランティア元年だと言われていますが、やはり日本のボランティアカルチャーと災害は切っても切り離せない関係にあると思います。',
        'その一方、近年は災害が複雑化していて、水害ひとつとっても同時多発的に起こることが増えており、ボランティアが足りないという局面を迎えています。',
        '我々はセミナーを開いたりトレーニングを行ったりしていますが、まだまだ追いつかない状況です。そうした状況に対し、既存の取り組みに加え今回のVR体験など新しい試みを通して、少しでもボランティアに興味を持っている人が、一人でも多く災害現場のボランティアとして活躍し、被災地が1日も早く復興するという流れを、今後さらに進めていきたいと思っています。',
      ],
    },
  ],
]

gsap.registerPlugin(ScrollTrigger)
const tweenVars: gsap.TimelineVars = {
  y: 50,
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

const Interview: React.FC = () => {
  const timeline = gsap.timeline()
  const wrapper = useRef<HTMLElement>(null)
  const image = useRef<HTMLImageElement>(null)
  const text_container = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (image.current && text_container.current) {
      timeline.from(image.current, tweenVars, 0.2)
      timeline.from(text_container.current, tweenVars, 0.4)

      ScrollTrigger.create({
        animation: timeline,
        trigger: wrapper.current,
        start: 'top-=100 80%',
        toggleActions: 'play none none reverse',
      })
    }
  }, [])

  return (
    <section className={styles.wrapper} ref={wrapper}>
      <div className={styles.content}>
        <TitleFlex sectionTitle={sectionTitle} />
        <div className={styles.article_container} ref={text_container}>
          <InterviewContents contentData={contentData} />
        </div>
      </div>
    </section>
  )
}

export default Interview
